import { Modal, Typography, Button } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { IConfirmModalProps, IStyleProps } from './types';
import useStyles from './style';

const ConfirmModal = ({
  title,
  message,
  open,
  onDecline,
  onAccept,
  hideConfirmMessage = false,
  width,
}: IConfirmModalProps & IStyleProps) => {
  const classes = useStyles({ width } as IStyleProps);

  return (
    <Modal open={open} onClose={onDecline} className={classes.presentation}>
      <div className={classes.modalPresentation}>
        <div className={classes.modalCard}>
          <div className={classes.modalHeader}>
            <Typography variant="h3" className={classes.headerTitle}>
              {title}
            </Typography>
            <Close className={classes.headerIcon} onClick={onDecline} />
          </div>
          <div className={classes.modalBody}>
            <Typography variant="subtitle1" className={classes.bodyText}>
              {message}
            </Typography>
            {!hideConfirmMessage && (
              <Typography variant="subtitle2" className={classes.bodyText}>
                Deseja confirmar?
              </Typography>
            )}
          </div>
          <div className={classes.modalFooter}>
            <Button onClick={onDecline} color="secondary">
              Cancelar
            </Button>
            <Button onClick={onAccept} color="primary" autoFocus>
              Confirmar
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export default ConfirmModal;
